var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TRC-CreditAmountContainer"},[_vm._v("\n    "+_vm._s(_vm.shopModule.shop.currency_symbol)),(_vm.negative)?[_vm._v("-")]:_vm._e(),_vm._v(_vm._s(_vm.amount)+" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.credit_label')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }